export default __webpack_public_path__ + "c6dcfe002716d0088c30783e471b2c1f.png";